import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import './style.css'
import App from './App.vue'
import router from './router';
import { checkSecurityDev } from './utils/security'
import { initializeShopifyAuth } from './utils/shopifyAuth'

// 在应用启动前进行安全检查
checkSecurityDev()

// 初始化Shopify认证参数
initializeShopifyAuth()

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(Antd);
app.mount('#app');
